import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { EstimatedReconciliationService } from 'app/services/estimated-reconciliation.service';
import { TrueUpFeatureModel } from 'app/models/true-up.model';

@Injectable()
export class TrueUpConfigResolver  {

    constructor(private service: EstimatedReconciliationService)
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<TrueUpFeatureModel> {
        return this.service.GetTrueUpConfig();
    }
}
